const GoogleMapComp = () => {};

export default GoogleMapComp;
